import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c41cc7f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "over-sea-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'tiktok'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm', 'setVisible'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const divideList = ref([]);
    const tiktokRef = ref(null);
    const tiktokForm = reactive({
      divide: '0.8',
      pkg: '',
      appId: '',
      appSecret: ''
    });
    const validateForm = () => {
      var _tiktokRef$value;
      (_tiktokRef$value = tiktokRef.value) === null || _tiktokRef$value === void 0 || _tiktokRef$value.validate().then(() => {
        emit('submitForm', tiktokForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        tiktokForm.pkg = n.pkg;
        tiktokForm.appId = n.appId;
        tiktokForm.appSecret = n.appSecret;
        tiktokForm.divide = n.divide;
        tiktokForm.id = n.id;
        divideList.value = n.rateList;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: tiktokForm,
        ref_key: "tiktokRef",
        ref: tiktokRef,
        rules: __props.rules,
        name: "tiktok-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: tiktokForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => tiktokForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "AppID："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: tiktokForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => tiktokForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appSecret",
          label: "AppSecret："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: tiktokForm.appSecret,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => tiktokForm.appSecret = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "divide",
          label: "分成系数："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: tiktokForm.divide,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => tiktokForm.divide = $event),
            options: divideList.value
          }, null, 8, ["value", "options"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});